import logger from 'src/utils/logger';

/**
 * Parses a raw WebSocket message, filtering out empty frames (keep-alive)
 * and empty messages (e.g. "[]" sent on connection).
 * Returns the parsed value, or null if the message should be skipped.
 */
const parseWsMessage = <T = unknown>(lastMessage: MessageEvent | null): T | null => {
  // Skip empty binary frames (keep-alive) and non-string messages
  if (!lastMessage?.data || typeof lastMessage.data !== 'string' || lastMessage.data.length === 0) return null;

  let message: unknown;
  try {
    message = JSON.parse(lastMessage.data);
  } catch {
    logger.warn('Failed to parse WS message', { data: lastMessage.data });

    return null;
  }

  // Skip empty string messages
  if (typeof message === 'string' && !message) return null;

  return message as T;
};

export default parseWsMessage;
